import teamImg from '../../../img/our-team.png';



export default function FarmingSection() {
  return (
    <section className="bg-[#1A1A1A] py-24 md:py-36 px-8 md:px-16 overflow-hidden">
      <div className="w-full">
        {/* Section header */}
        <div className="flex flex-col lg:flex-row items-start gap-8 mb-20">
          <span
            className="text-white/10 font-black leading-none select-none flex-shrink-0"
            style={{ fontFamily: "'Bebas Neue', sans-serif",marginTop: '-12px', fontSize: 'clamp(80px, 16vw, 236px)', lineHeight: 1 }}
          >
            03
          </span>
          <div className="flex-1">
            <h2
              className="text-white font-black uppercase leading-none mb-6"
              style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(40px, 7vw, 100px)' }}
            >
              OUR
              <br />
              <span className="text-[#FFD93D]">TEAM</span>
            </h2>
            <p className="text-white/60 font-bold text-xl md:text-2xl uppercase tracking-widest">
              Experienced professionals united by a passion for technology.
            </p>
          </div>
        </div>

        {/* Content grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 border-2 border-white/10 rounded-[40px] overflow-hidden">
          {/* Left: Image */}
          <div className="relative overflow-hidden lg:min-h-full" style={{ minHeight: '500px' }}>
            <img
              src={teamImg}
              alt="Regent Digital team"
              className="absolute inset-0 w-full h-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#1A1A1A]/70" />
            {/* Badge */}
            <div className="absolute top-8 left-8 bg-[#FFD93D] rounded-full w-36 h-36 flex flex-col items-center justify-center text-center">
              <span
                className="text-black font-black leading-none"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '28px' }}
              >
                UK
              </span>
              <span
                className="text-black font-black leading-none"
                style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: '20px' }}
              >
                BASED
              </span>
            </div>
          </div>

          {/* Right: Content */}
          <div className="p-10 md:p-16 flex flex-col justify-center">
            <div className="space-y-10">
              {[
                {
                  icon: 'ri-user-star-line',
                  title: 'PROJECT MANAGERS',
                  desc: 'Senior PMs who keep every project on track — on time, on budget, and always in sync with your goals.',
                },
                {
                  icon: 'ri-terminal-line',
                  title: 'DEVELOPERS',
                  desc: 'Full-stack engineers with deep expertise in modern web, mobile, cloud, and backend technologies.',
                },
                {
                  icon: 'ri-palette-line',
                  title: 'UI/UX DESIGNERS',
                  desc: 'Designers who combine aesthetic sense with data-driven thinking to create interfaces people actually enjoy using.',
                },
                {
                  icon: 'ri-megaphone-line',
                  title: 'MARKETERS & QA ENGINEERS',
                  desc: 'Marketers who amplify product reach and QA engineers who ensure nothing ships until it\'s flawless.',
                },
              ].map((item) => (
                <div key={item.title} className="flex gap-6 items-start">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#FFD93D] rounded-2xl flex-shrink-0">
                    <i className={`${item.icon} text-black text-2xl`} />
                  </div>
                  <div>
                    <h3
                      className="text-white font-black uppercase text-2xl md:text-3xl mb-2"
                      style={{ fontFamily: "'Bebas Neue', sans-serif" }}
                    >
                      {item.title}
                    </h3>
                    <p className="text-white/60 font-semibold text-base md:text-lg leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Big tagline */}
        <div className="mt-20 text-center">
          <p
            className="text-white font-black uppercase leading-none"
            style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 'clamp(36px, 6vw, 80px)' }}
          >
            "WE DON'T JUST BUILD SOFTWARE —
            <br />
            <span className="text-[#FFD93D]">WE BUILD YOUR COMPETITIVE EDGE."</span>
          </p>
        </div>
      </div>
    </section>
  );
}
